import Vue from "vue"
import Router from "vue-router"
import Login from "@/components/Login"
import Dashboard from "@/components/Dashboard"
import AppCtrlCenter from "@/components/AppCtrlCenter"

import store from '../store'



Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "Home",
      component: Login
    },

    {
        path: "/login",
        name: "Login",
        component: Login
    },
  
    {
        path: "/dashboard",
        name: "Security Control Center",
        component: Dashboard,
        beforeEnter: (to, from, next) => {
          if ('' == store.state.token) next({ name: 'Login' })
          else next()
        },

        meta: { 
          requiresAuth: true 
        }
    },

    {
      path: "/appCtrlCenter",
      name: "Application Control Center",
      component: AppCtrlCenter,
      beforeEnter: (to, from, next) => {
        if ('' == store.state.token) next({ name: 'Login' })
        else next()
      },
  
      meta: { 
        requiresAuth: true 
      }
    },

    {
      path: "*",
      name: "Invalid_path",
      component: Login
    },
  
  ],

})